export enum EProfilePrivacy {
  Public = 0,
  Private = 1,
}
